import {
  INSUFFICIENT_INFORMATION_REGEX,
  MANUAL_INSTRUCTION_REGEX,
  MISSING_FIELD_PLACEHOLDER_REGEXES,
  normalizeMarkdownForSentinelParsing,
  normalizePlaceholderGuidanceAttribute,
  parsePlaceholderColonContent,
} from './complianceDocumentSentinelParsing'
import type { ComplianceDocumentSentinelDisplay } from './types'

export type ComplianceDocumentPlaceholderMessageType = 'not_found'

function interpolateTemplate(
  template: string,
  values: Record<string, string>,
): string {
  let result = template
  for (const [key, value] of Object.entries(values)) {
    result = result.split(`{{${key}}}`).join(value)
  }
  return result
}

export function formatComplianceDocumentPlaceholderMessage(
  _type: ComplianceDocumentPlaceholderMessageType,
  display: ComplianceDocumentSentinelDisplay,
  fieldLabel?: string | null,
  guidance?: string | null,
): string {
  const field = fieldLabel?.trim() ?? ''
  const guidanceText =
    normalizePlaceholderGuidanceAttribute(guidance)?.trim() ?? ''

  if (field && guidanceText) {
    return interpolateTemplate(display.notFoundWithFieldAndGuidance, {
      field,
      guidance: guidanceText,
    })
  }
  if (field) {
    return interpolateTemplate(display.notFoundWithField, { field })
  }
  return display.notFound
}

function replaceMissingFieldPlaceholders(
  markdown: string,
  display: ComplianceDocumentSentinelDisplay,
): string {
  let result = markdown
  for (const regex of MISSING_FIELD_PLACEHOLDER_REGEXES) {
    regex.lastIndex = 0
    result = result.replace(regex, (_match, rawPayload: string | undefined) => {
      const parsed = rawPayload
        ? parsePlaceholderColonContent(rawPayload)
        : null
      return formatComplianceDocumentPlaceholderMessage(
        'not_found',
        display,
        parsed?.fieldLabel ?? null,
        parsed?.guidance ?? null,
      )
    })
  }
  return result
}

export function localizeComplianceDocumentSentinelsInMarkdown(
  markdown: string,
  display: ComplianceDocumentSentinelDisplay,
): string {
  const normalizedMarkdown = normalizeMarkdownForSentinelParsing(markdown)

  let result = replaceMissingFieldPlaceholders(normalizedMarkdown, display)

  result = result.replace(MANUAL_INSTRUCTION_REGEX, (_match, rawInstruction) => {
    if (rawInstruction != null && rawInstruction.trim() !== '') {
      return rawInstruction.trim()
    }
    return ''
  })

  result = result.replace(
    INSUFFICIENT_INFORMATION_REGEX,
    () => display.insufficientInformation,
  )

  return result
}
